export default __webpack_public_path__ + "static/media/724.a241c11a.png";